<template>
    <v-app id="inspire" style="background-image: url('/bckAlumno.png'); background-repeat: no-repeat; background-position: right bottom 1%;" :style="{ 'background-color': dMessage.color }">
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-row justify="center" class="ma-0">
            <v-col v-if="dMessage.show" cols="12" sm="12" md="9" lg="9" class="pa-0">
                <div class="bg-blue text-white text-center q-pa-md flex flex-center">
                    <div>
                        <v-icon size="260" dark>{{ dMessage.icon }}</v-icon>
                    </div>
                    <h3 class="text-h2" style="font-size: 5vh; opacity:.8; color:white">
                        {{ dMessage.title }}
                    </h3>
                    <h4 class="text-h4" style="font-size: 3vh; opacity:.8; color:#444444">
                        {{ dMessage.body }}
                    </h4>
                    <ul v-if="dMsgError.length != 0" style="list-style: none; font-size: 2vh;">
                        <li v-for="(item,index) in dMsgError" :key="index">{{item.message}}</li>
                    </ul>
                </div>
            </v-col>
            <v-col v-else cols="12" sm="12" md="12" lg="12" class="pa-0">
                <v-card style="background-color:#f5f5f5" max-width="1000">
                    <v-card-text class="pa-0">
                        <v-expansion-panels focusable>
                            <v-expansion-panel 
                                v-for="item in dMatSecciones" :key="item.IdSeccion"
                                @click.prevent="fuSelected(item)"
                            >
                                <v-expansion-panel-header class="justify-self-start">
                                    <v-row no-gutters>
                                        <v-col cols="3">
                                            {{ item.matperiodo.Nivel + item.Seccion + ' ' + item.matperiodo.Anio + '-' + item.matperiodo.Periodo + ' ' + fuTurno(item.Turno) }} <v-icon>{{ fuTurnoIcono(item.Turno) }}</v-icon>
                                        </v-col>
                                        <v-col cols="2">
                                            <v-chip :color="dDiccionarioColor[item.CondicionMat]" label small><strong>{{ item.CondicionMat }}</strong></v-chip>
                                        </v-col>
                                        <v-col cols="2">
                                            <v-chip :color="fuColor12Fecha(item.FechaInicio)" outlined>{{ fuMesNombreFecha(item.FechaInicio) }}</v-chip>
                                        </v-col>
                                        <v-col cols="5">
                                            <v-icon>calendar_month</v-icon>Del {{ item.FechaInicio.substring(0,10) }} al {{ item.FechaFin.substring(0,10) }}
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <template>
                                        <v-simple-table dense>
                                            <template>
                                                <thead>
                                                    <tr style="background: #5F89A7;">
                                                        <th style="width: 20%" class="text-center">MES</th>
                                                        <th style="width: 20%" class="text-center">FECHA DE PAGO</th>
                                                        <th style="width: 20%" class="text-right">MONTO</th>
                                                        <th style="width: 20%" class="text-right">DESCUENTO</th>
                                                        <th style="width: 20%; background: #5F89A7; color: white" class="text-right">A PAGAR</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="item2 in dingcronogramapagosSelect" :key="item2.IdMes" style="border-bottom:2pt solid black;">
                                                        <td style="width: 20%" class="text-center">{{fuMesMensualidad(item2.IdMes)}}</td>
                                                        <td style="width: 20%" class="text-center">{{ item2.FechaDeuda.substring(0,10) }}</td>
                                                        <td style="width: 20%" class="text-right">S/. {{ item2.Monto }}</td>
                                                        <td style="width: 20%" class="text-right"><v-chip v-if="item2.Descuento>0" color="orange" outlined><h3>S/. {{ item2.Descuento }}</h3></v-chip></td>
                                                        <td style="width: 20%; background: #7BA1BD; color: white" class="text-right font-weight-bold">S/. {{ item2.Monto - item2.Descuento }}</td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colspan="3">
                                                            <v-select
                                                                v-if="dPromocionsFilter.length>0"
                                                                :items="dPromocionsFilter"
                                                                v-model="dPromocionsFilter_id"
                                                                item-value="id"
                                                                item-text="matpromocion.promocion"
                                                                label="Seleccione promoción"
                                                                chips
                                                            ></v-select>
                                                        </td>
                                                        <td>
                                                            <v-btn v-if="dPromocionsFilter.length>0" @click="fuCronogramaReset(item.ingcronogramapagos)" outlined color="grey" title="Restaurar Cronograma"><v-icon left>restart_alt</v-icon>Restaurar</v-btn>
                                                        </td>
                                                        <td>
                                                            <v-btn @click.prevent="fuMatriculaSave(item.IdSeccion, item.CondicionMat)" :disabled="dingcronogramapagosSelect.length<=1" color="primary"><v-icon left>save</v-icon> Matricular</v-btn>
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </template>
                                        </v-simple-table>
                                    </template>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-app>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {fuColor12Fecha, fuTurno, fuTurnoIcono, fuMesNombreFecha, fuMesMensualidad} from '@/helpers/index.js';

export default {
    name: 'MatriculaByAlumno',
    props: {
        pIdAlumno: {
            type: Number,
            required: true,
        },
    },
    mounted(){
        if (this.pIdAlumno)
            this.fuLoad(parseInt(this.pIdAlumno));
    },
    data: () => ({
        dLoading : false,
        dingcronogramapagosSelect: {},
        dMatMatriculaLast: null,
        dDiccionarioColor: {
            REGULAR : 'success',
            REINICIO : 'warning',
            REPITENCIA : 'error',
            'POR CURSO' : 'orange',
            'TRASLADO EXTERNO' : 'primary'
        },
        dMessage: {
            show: false,
            title: "",
            body: "",
            icon: "",
            color: "#b3e5fc",//#EF9A9A  b3e5fc
        },
        dMessageDefault: {
            show: false,
            title: "",
            body: "",
            icon: "",
            color: "#b3e5fc",//#EF9A9A  b3e5fc
        },
        dMsgError: [],
        dMatSecciones: [],
        dMatSeccionSelected: null,
        dPromocions: [],
        dPromocionsFilter: [],
        dPromocionsFilter_id: null,
        dNivel: null,
        dIdServicio: null,
        dSeccionSelected: null
    }),
    watch: {
        pIdAlumno(val){
            if(val){
                this.dMessage = this.dMessageDefault;
                this.fuLoad(val);
            }
        },
        dPromocionsFilter_id(val){
            if(val){
                this.dingcronogramapagosSelect = this.dingcronogramapagosSelect.map(obj => ({
                    ...obj,
                    Descuento: 0
                }));

                const vPromociones = this.dPromocionsFilter.find(item => item.id == val).matpromocioncronogramas;

                vPromociones.forEach((item) => {
                    if(!item.is_porcentaje)
                        this.dingcronogramapagosSelect[item.nro_cuota].Descuento = item.descuento;
                    else{
                        this.dingcronogramapagosSelect[item.nro_cuota].Descuento = ((parseFloat(this.dingcronogramapagosSelect[item.nro_cuota].Monto) * parseFloat(item.descuento))/parseFloat(100)).toFixed(2);
                        // this.dingcronogramapagosSelect[item.nro_cuota].Descuento =  Number(item.descuento)/Number(100);
                    }
                    
                })
            }
        },
    },
    computed: {
        ...mapState(['ssUser']),
    },
    methods: {
        fuColor12Fecha, fuTurno, fuTurnoIcono, fuMesNombreFecha, fuMesMensualidad,
        async fuLoad(p_IdAlumno) {
            this.dLoading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query matriculaPrev($IdAlumno: ID!, $CondicionMat: String!){
                            matmatriculaCreateValidate(IdAlumno: $IdAlumno, CondicionMat: $CondicionMat){
                                error
                                data
                                message
                            }
                            matseccionAMatricular(IdAlumno: $IdAlumno){
                                IdSeccion
                                Seccion
                                Turno
                                FechaInicio
                                FechaFin
                                matperiodo{
                                    Anio
                                    Periodo
                                    Nivel
                                    IdServicio
                                }
                                ingcronogramapagos{
                                    IdCronograma
                                    IdMes
                                    FechaDeuda
                                    Monto
                                    IdEscala
                                }
                            }
                            matmatriculaLast(IdAlumno:$IdAlumno){
                                IdMatricula
                                matseccion{
                                    IdSeccion
                                    Seccion
                                    matperiodo{
                                        Nivel
                                        Anio
                                        Periodo
                                    }
                                }
                            }
                            matmatriculasByIdAlumno(IdAlumno: $IdAlumno){
                                IdSeccion
                                matseccion{
                                    matperiodo{
                                        Anio
                                        Periodo
                                        Nivel
                                    }
                                }
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: p_IdAlumno,
                        CondicionMat: 'WEB'
                    }
                })
                const vmatmatriculasByIdAlumno = response.data.matmatriculasByIdAlumno || [];

                vmatmatriculasByIdAlumno.sort((a, b) => {
                    const nivelA = a.matseccion.matperiodo.Nivel;
                    const nivelB = b.matseccion.matperiodo.Nivel;

                    if (nivelA < nivelB) return 1;
                    if (nivelA > nivelB) return -1;

                    const seccionA = a.IdSeccion;
                    const seccionB = b.IdSeccion;

                    if (seccionA < seccionB) return 1;
                    if (seccionA > seccionB) return -1;

                    return 0;
                });

                this.dMatMatriculaLast = vmatmatriculasByIdAlumno.length > 0 
                    ? vmatmatriculasByIdAlumno[0] 
                    : null;

                this.dMsgError = response.data.matmatriculaCreateValidate;
                let secciones = response.data.matseccionAMatricular.filter(seccion => {
                    return seccion.ingcronogramapagos && seccion.ingcronogramapagos.length > 1;
                });

                this.dMatSecciones = secciones.map(item => {
                    if (item.ingcronogramapagos && Array.isArray(item.ingcronogramapagos)) {
                        
                        item.ingcronogramapagos.sort((a, b) => {
                            const dateA = moment(a.FechaDeuda);
                            const dateB = moment(b.FechaDeuda);
                            
                            return dateA.valueOf() - dateB.valueOf();
                        });
                    }
                    this.dNivel = item.matperiodo.Nivel;
                    this.dIdServicio = item.matperiodo.IdServicio;

                    item.CondicionMat = this.fuCondicionMatSelect(item.matperiodo.Anio + '-' + item.matperiodo.Periodo, item.matperiodo.Nivel);
                    return item;
                });

                this.dMatSecciones.sort((a, b) => {
                    const inicioA = moment(a.FechaInicio);
                    const inicioB = moment(b.FechaInicio);
                    return inicioA.valueOf() - inicioB.valueOf();
                });
                
                if(this.dMatSecciones.length<=0){
                    this.dMsgError.push({ error:1, message: "No hay secciones a matricularse", data:""});
                }

                if(this.dMsgError.length>0)
                    this.dMessage = { show: true, title: "No puede matricularse", body: "", icon: "cancel", color: "#EF9A9A"};
                else {
                    if(this.ssUser){
                        const arrayPersonal = ['larenas', 'cquispeh', 'jabrill', 'cgalindo','ddaza','echampi','kenriquez','mpuelles','rrmora','yaguilar','jaguilar','ymena','mguzman'];
                        if(arrayPersonal.includes(this.ssUser.Usuario)){
                            this.fumatpromocionservicionivelturnoByIdServicioByNivelByis_active(Number(this.dIdServicio), Number(this.dNivel));
                        }
                    }
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
        fuSelected(vItem){
            this.dingcronogramapagosSelect = {};
            this.dMatSeccionSelected=vItem;
            this.dSeccionSelected = vItem.matperiodo.Nivel + vItem.Seccion + ' - ' + this.fuTurno(vItem.Turno) + ' - ' + this.fuMesNombreFecha(vItem.FechaInicio);

            let vCronograma = JSON.parse(JSON.stringify(vItem.ingcronogramapagos));
            this.dingcronogramapagosSelect = vCronograma.map(obj => ({
                ...obj,
                Descuento: 0
            }));

            this.fuPromocionFilter(vItem.matperiodo.Nivel, vItem.Turno);
        },
        fuCondicionMatSelect(vPeriodo, vNivel){            
            // %%%%%%%%%%%%%%%% Cachimbo %%%%%%%%%%%%%%%%            
            if(!this.dMatMatriculaLast)
                return "REGULAR";

            // %%%%%%%%%%%%%%%% REINICIO %%%%%%%%%%%%%%%%
            var today = new Date();
            var vYear = today.getFullYear() + 1;

            let vYears = [];
            for (var i = vYear; i >= vYear-40; i--) {
                vYears.push(i+'-2');
                vYears.push(i+'-1');
            }

            let indexAMatricular = vYears.indexOf(vPeriodo);
            let indexLast = vYears.indexOf(this.dMatMatriculaLast.matseccion.matperiodo.Anio + '-' + this.dMatMatriculaLast.matseccion.matperiodo.Periodo);

            if(indexLast-indexAMatricular > 1)
                return "REINICIO";
            
            // %%%%%%%%%%%%%%%% REPITENCIA %%%%%%%%%%%%%%%%
            let vMatMatriculaLast_nivel=0;
            vMatMatriculaLast_nivel = this.dMatMatriculaLast.matseccion.matperiodo.Nivel;
            
            if(vMatMatriculaLast_nivel==vNivel)
                return "REPITENCIA"

            return "REGULAR";
        },
        fuMatriculaSave (vIdSeccion, vCondicionMat) {
            Swal.fire({
                icon: 'question',
                title: '¿Estás seguro de Matricular en?',
                html: '<h3>'+this.dSeccionSelected+'</h3>',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, matricular',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.fuMatriculaCreateCronograma(vIdSeccion, vCondicionMat);
                },
            })
        },
        async fuMatriculaCreateCronograma(vIdSeccion, vCondicionMat) {
            let vid_promocion = null;
            if(this.dPromocionsFilter_id)
                vid_promocion = this.dPromocionsFilter.find(item => item.id == this.dPromocionsFilter_id).id_promocion;

            try {
                this.dLoading = true;
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation matmatriculaCreateCronograma(
                        $IdSeccion: String,
                        $IdAlumno: String,
                        $FechaMatricula: String,
                        $IdCurricula: String,
                        $Observacion: String,
                        $Grupo: String,
                        $Condicion: String,
                        $CondicionMat: String,
                        $Operador: String,
                        $Accion: String,
                        $ingcronogramapagos: String,
                        $id_promocion: Int,
                    ){
                        matmatriculaCreateCronograma(
                            IdSeccion: $IdSeccion,
                            IdAlumno: $IdAlumno,
                            FechaMatricula: $FechaMatricula,
                            IdCurricula: $IdCurricula,
                            Observacion: $Observacion,
                            Grupo: $Grupo,
                            Condicion: $Condicion,
                            CondicionMat: $CondicionMat,
                            Operador: $Operador,
                            Accion: $Accion,
                            ingcronogramapagos: $ingcronogramapagos,
                            id_promocion: $id_promocion
                        ){
                            error
                            message
                            data
                        }
                    }`,
                    variables: {
                        IdSeccion : vIdSeccion,
                        IdAlumno : this.pIdAlumno,
                        FechaMatricula : moment().format("YYYYMMDD HH:mm:ss"),
                        IdCurricula : "0",
                        Observacion : "",
                        Grupo : "1",
                        Condicion : "REGULAR",
                        CondicionMat : vCondicionMat,
                        Operador : this.ssUser ? this.ssUser.Usuario : 'web',
                        Accion : "A",
                        ingcronogramapagos : JSON.stringify(this.dingcronogramapagosSelect),
                        id_promocion: vid_promocion
                    }
                });
                if(response.data.matmatriculaCreateCronograma.error==0){
                    this.dIdMatricula = response.data.matmatriculaCreateCronograma.data;
                    this.dMessage = { show: true, icon: "thumb_up", color: "#b3e5fc", title: response.data.matmatriculaCreateCronograma.message, body: "", items: []};
                    this.$emit('fuMatriculaList');
                } else {
                    Swal.fire('¡ ERROR !', response.data.matmatriculaCreateCronograma.message, 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó la matricula.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
        async fumatpromocionservicionivelturnoByIdServicioByNivelByis_active(pIdServicio, pNivel) {
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query matpromocionservicionivelturnoByIdServicioByNivelByis_active($IdServicio: Int!, $Nivel: Int!, $is_active: Int!){
                            matpromocionservicionivelturnoByIdServicioByNivelByis_active(IdServicio: $IdServicio, Nivel: $Nivel, is_active: $is_active){
                                id
                                id_promocion
                                Nivel
                                Turno
                                matpromocion{
                                    promocion
                                }
                                matpromocioncronogramas{
                                    nro_cuota
                                    descuento
                                    is_porcentaje
                                }
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdServicio: pIdServicio,
                        Nivel: pNivel,
                        is_active: 1
                    }
                });
                this.dPromocions = response.data.matpromocionservicionivelturnoByIdServicioByNivelByis_active;
                
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
            }
        },
        fuPromocionFilter(vNivel, vTurno){
            this.dPromocionsFilter = [];
            this.dPromocionsFilter_id = null;
            this.dPromocionsFilter = this.dPromocions.filter(item => item.Nivel == vNivel && item.Turno == vTurno);
        },
        fuCronogramaReset(vItem){
            this.dPromocionsFilter_id = null;
            let vCronograma = JSON.parse(JSON.stringify(vItem));
            this.dingcronogramapagosSelect = vCronograma.map(obj => ({
                ...obj,
                Descuento: 0
            }));
        },
    }
}
</script>
<style scoped>
tr:nth-child(even) {
  background-color: #E3F2FD;
}
::v-deep .v-select .v-chip {
  /* Establece el color de fondo para la promocion*/
  background-color: orange !important; 
  color: white !important;
}
</style>
